import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';
import { USER_ADMIN_TYPES } from '../../../App';
import { useAuth } from '../../../commons/Auth';

const TotalTr = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
}) => {
  const {
    cashedTotals = 0,
    netTotals = 0,
    grossTotals = 0,
    commercialShareTotals = 0,
    earnedCommercialShareTotals = 0,
    billableCommercialShareTotals = 0,
  } = totals;

  const [{ newUserType = '' }] = useAuth();

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}

      <td
        className={
          newUserType === USER_ADMIN_TYPES.SUPER_ADMIN
            ? `txt-table-right`
            : `txt-table-center`
        }
      >
        {formatCurrency(netTotals)}
      </td>
      <td
        className={
          newUserType === USER_ADMIN_TYPES.SUPER_ADMIN
            ? `txt-table-right`
            : `txt-table-center`
        }
      >
        {formatCurrency(grossTotals)}
      </td>
      <td
        className={
          newUserType === USER_ADMIN_TYPES.SUPER_ADMIN
            ? `txt-table-right`
            : `txt-table-center`
        }
      >
        {formatCurrency(cashedTotals)}{' '}
      </td>
      {!truncateTotals && newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td className="txt-table-right">-</td>
      )}
      {newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td className="txt-table-right">
          {formatCurrency(commercialShareTotals)}
        </td>
      )}
      {newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td className="txt-table-right">
          {formatCurrency(earnedCommercialShareTotals)}
        </td>
      )}
      {newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td className="txt-table-right">
          {formatCurrency(billableCommercialShareTotals)}{' '}
        </td>
      )}
      {!truncateTotals && newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td>-</td>
      )}
      {!truncateTotals && newUserType === USER_ADMIN_TYPES.SUPER_ADMIN && (
        <td>-</td>
      )}
    </tr>
  );
};

export default TotalTr;
